import { ViajeTrasladoCreateModelLegacyDontUse, ViajeTrasladoTipoServicio } from 'app/viaje/models';
import { Moment } from 'moment';
import {
  transferReservationBaseFormBuilder,
  TransferReservationBaseFormType,
  transferReservationBaseLocationFormBuilder,
  TransferReservationBaseLocationFormType
} from '../../../viajeTraslado/forms/base/TransferReservationBaseFormTypes';
import { RateModel } from 'app/client/clientBusiness/rates/models/RateModel';
import { AirportDetails } from '../../models/TransferReservationPartial';
import { EventModel } from 'app/eventos/models/Evento';

export interface TransferReservationBatchLocationFormType
  extends TransferReservationBaseLocationFormType { }

/*
 Esta reserva permite crear multiples viajes.
 Cada viaje tiene el tipo TransferReservationBatchTripFormType 
*/
export type TransferReservationBatchTripFormType = {
  prioridad: boolean;
  tipoServicio: ViajeTrasladoTipoServicio;
  fixedRate: RateModel['categories'][0]['fixedPrices'][0] | null;
  hasOutSite: boolean;
  bus_provider_price?: number;
  bus_customer_price?: number;
  bus_is_outsourced?: boolean;
  bus_observation?: string;
  bus_type_id?: number;
  bus_vehicle_id?: number;
  puntos: TransferReservationBatchLocationFormType[];
  fechaYHoraDeLlegada: Moment;
  minutosPreviosASalida: Moment;
  reason_reserve_past?: string;
};

export interface TransferReservationBatchFormType
  extends TransferReservationBaseFormType {
  viajes: TransferReservationBatchTripFormType[];
  reason_reserve_past?: string | null;
  airport_details?: AirportDetails | null;
  event?: EventModel | null;
}

function viajeTrasladoBatchFormToModel(
  form: TransferReservationBatchFormType
): ViajeTrasladoCreateModelLegacyDontUse[] {
  console.log(form)
  return form.viajes.map((detallesTraslado) => {
    const fechaYHoraDeLlegada = detallesTraslado.fechaYHoraDeLlegada;
    const fechaYHoraDeSalida = detallesTraslado.minutosPreviosASalida;
    return {
      ...transferReservationBaseFormBuilder.toModel(form),
      bus_requirement: detallesTraslado.tipoServicio === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES ? {
        bus_type_id: detallesTraslado?.bus_type_id ?? 0,
        vehicle_id:
          detallesTraslado?.bus_vehicle_id && detallesTraslado.bus_vehicle_id > 0
            ? detallesTraslado.bus_vehicle_id
            : null,
        provider_price: detallesTraslado?.bus_provider_price || 0,
        customer_price: detallesTraslado?.bus_customer_price || 0,
        is_outsourced: detallesTraslado?.bus_is_outsourced ? true : false,
        observation: detallesTraslado?.bus_observation ?? ''
      }
        : null,
      prioridad: detallesTraslado.prioridad,
      tipoServicio: detallesTraslado.tipoServicio,
      fixedRate: detallesTraslado.fixedRate,
      hasOutSite: detallesTraslado.hasOutSite,
      fechaYHoraDeLlegada: fechaYHoraDeLlegada,
      fechaYHoraDeSalida: fechaYHoraDeSalida,
      puntos: detallesTraslado.puntos.map(
        transferReservationBaseLocationFormBuilder.toModel
      ),
      reason_reserve_past: detallesTraslado.reason_reserve_past ?? null,
      airport_details: form.airport_details,
      event_id: form.event?.id,
    };
  });
}

export const transferReservationBatchFormBuilder = {
  toModel: viajeTrasladoBatchFormToModel
};
